/**
 * Recorte das células de uma linha para o card de celular.
 *
 * No card antigo todas as colunas viravam linha rótulo/valor e as ações ficavam
 * no fim — em telas como Saques eram oito linhas antes do botão, o que obrigava a
 * rolar até o fim do card para acessar o pagamento. Aqui a seleção, o campo de
 * destaque e as ações saem separados para o cabeçalho, e o excesso de campos fica
 * atrás de "Mais detalhes".
 */
export const MOBILE_CARD_VISIBLE_FIELDS = 4;

type CellLike = { column: { id: string } };

export type MobileCardFields<T extends CellLike> = {
  /** Checkbox de seleção, quando a tabela tem seleção. */
  selection: T[];
  /** Botões de ação da linha. */
  actions: T[];
  /** Primeira coluna da tabela: vira o título do card. */
  title: T | null;
  /** Campos exibidos direto (contando com o título). */
  visible: T[];
  /** Campos atrás de "Mais detalhes". */
  hidden: T[];
};

export function splitMobileCardFields<T extends CellLike>(
  cells: T[],
  visibleCount: number = MOBILE_CARD_VISIBLE_FIELDS,
): MobileCardFields<T> {
  const selection = cells.filter((cell) => cell.column.id === 'selection');
  const actions = cells.filter((cell) => cell.column.id === 'actions');
  const fields = cells.filter(
    (cell) => cell.column.id !== 'selection' && cell.column.id !== 'actions',
  );

  const limit = Math.max(1, visibleCount);

  return {
    selection,
    actions,
    title: fields[0] ?? null,
    visible: fields.slice(1, limit),
    hidden: fields.slice(limit),
  };
}
